module.exports = __webpack_public_path__ + "img/change-outline-blue.e811264b.svg";